/**
 * @sw-package innovation
 *
 * @experimental stableVersion:v6.8.0 feature:SpatialSceneEditor
 */

const PluginManager = (window as unknown as StorefrontWindow).PluginManager;

PluginManager.override(
    'SpatialGallerySliderViewer',
    () => import('./plugin/spatial-scene-gallery-slider-viewer.plugin'),
    '[data-spatial-gallery-slider-viewer]',
);

PluginManager.override(
    'SpatialZoomGallerySliderViewer',
    () => import('./plugin/spatial-scene-zoom-gallery-slider-viewer.plugin'),
    '[data-spatial-zoom-gallery-slider-viewer]',
);
